import {
  CallIntelFeedbackMockRouter,
  CallIntelInsightPanelMockRouter,
  CallIntelTasksMockRouter,
  CallIntelTssMockRouter,
} from '../feature-mock-routers';
import { UseCallIntelDemoInterceptorProps, useCallIntelDemoInterceptors } from './use-call-intel-demo-interceptors';

const INTERCEPTOR_ROUTERS = [
  CallIntelInsightPanelMockRouter,
  CallIntelTasksMockRouter,
  CallIntelTssMockRouter,
  CallIntelFeedbackMockRouter,
];

type UseCallInsightPanelDemoInterceptorsProps = Pick<
  UseCallIntelDemoInterceptorProps,
  'enabled' | 'interceptorIdPrefix'
>;

export const useCallInsightPanelDemoInterceptor = ({
  interceptorIdPrefix = 'call-intel-insight-demo',
  enabled,
}: UseCallInsightPanelDemoInterceptorsProps) => {
  return useCallIntelDemoInterceptors({
    enabled,
    interceptorIdPrefix,
    interceptorRouters: INTERCEPTOR_ROUTERS,
    demoTriggerSource: 'CALL_INSIGHT_PANEL',
  });
};
